
document.addEventListener('change', function(e){
  if(e.target.matches('[data-dbd-variant-select]')){
    var option=e.target.options[e.target.selectedIndex];
    var price=option.getAttribute('data-price');
    var available=option.getAttribute('data-available') === 'true';
    var form=e.target.closest('form');
    if(form){
      var id=form.querySelector('input[name="id"]');
      if(id) id.value=e.target.value;
      var btn=form.querySelector('[data-dbd-add]');
      if(btn){
        btn.disabled=!available;
        btn.textContent=available?'Add to cart':'Sold out';
      }
    }
    var priceEl=document.querySelector('[data-dbd-price]');
    if(priceEl && price) priceEl.textContent=price;
  }
});
